<div class="grid">
	<div class="col-12">
		<div class="card">
			<h4>Empty Page</h4>
			<p>This is your empty page template to start building beautiful applications.</p>
		</div>
	</div>
</div>
